import { combineReducers } from 'redux'
import InsightHighlightsReducer from './InsightHighlightsReducer'
import LearningTracksReducer from './LearningTracksReducer'
import BreadcrumbTrailReducer from './BreadcrumbTrailReducer'
import ProfileReducer from '../reducers/ProfileReducer'
import WorkspacesReducer from '../reducers/WorkspacesReducer'

const reducer =  combineReducers({
  insightHighlights: InsightHighlightsReducer.reducer,
  learningTracks: LearningTracksReducer.reducer,
  breadcrumbTrail: BreadcrumbTrailReducer.reducer,
  profile: ProfileReducer.reducer,
  workspaces: WorkspacesReducer.reducer
})

export default reducer;

export type IRootState = ReturnType<typeof reducer>

export const initialState = {
  insightHighlights: {
    isFetching: false,
    highlights: undefined
  },
  learningTracks: {
    learningTracks: undefined,
    latestTrack: undefined,
    showIntroModal: false,
    introModalViewed: false,
    checkTrackCompleteModal: false,
    trackCompleteModalSeen: false,
    isOrgAdmin: false,
    latestTrackStep: undefined
  },
  breadcrumbTrail: {
    breadcrumbs: []
  },
  profile: {
    profileImage: '',
    userName: ''
  },
  workspaces: {
    allWorkspaces: [],
    top5Workspaces:[],
    workspacesRemaining: 0,
    totalWorkspaces: 0
  }
}